module.exports = __webpack_public_path__ + "static/r13-31e17fff8b60f445c4f069981e028e93.jpg";